module.exports = __webpack_public_path__ + "img/f6.c5e7ace7.jpg";